// TEMPLATE TODO: update path and action type
export const apiPath = '/v2/service_integrations';
const actionType = 'SERVICE_INTEGRATIONS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
